import React, { Dispatch, SetStateAction } from 'react';
import styled from '../../../components/styled';

import { DateTimeField } from '../../../components';

interface StartActionFieldProps {
  startTime: string;
  onChange: Dispatch<SetStateAction<string>>;
}

const StartActionField = ({ startTime, onChange }: StartActionFieldProps) => {
  return (
    <>
      <Description>Start Time:</Description>
      <View>
        <DateTimeField
          disabled={false}
          value={startTime && new Date(`${startTime}`)}
          onValueChange={onChange}
        />
      </View>
    </>
  );
};

export default StartActionField;

const Description = styled.Text`
  margin-top: 10px;
  font-weight: 500;
  margin-bottom: 7px;
`;

const View = styled.View`
  flex-direction: row !important;
  align-items: center;
`;
